<app-information-screen [secondaryColor]="secondaryColor"
                        [title]="title"
                        [primaryContent]="description">
</app-information-screen>

@if (slides?.length) {

<div class="instruction-carousel" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">

  @if (slides[currentSlideIndex].title) {
  <h3 class="slide-title">
    {{ slides[currentSlideIndex].title }}
  </h3>
  }

  @if (slides[currentSlideIndex].requiresPin && !unlockPin) {
  <p class="slide-caption">
    {{ slides[currentSlideIndex].waitingForPinText }}
  </p>
  } @else if (slides[currentSlideIndex].text) {
  <p class="slide-caption">
    {{ slides[currentSlideIndex].text }}
  </p>
  }

  <div class="carousel-image-wrapper">
    @if (shouldShowVideo(currentSlideIndex)) {
    <video class="instruction-image"
           [src]="slides[currentSlideIndex].video"
           autoplay
           muted
           loop
           playsinline
           preload="metadata"
           (error)="onVideoError(currentSlideIndex)">
    </video>
    } @else {
    <img class="instruction-image"
         [src]="slides[currentSlideIndex].image"
         [alt]="slides[currentSlideIndex].alt || slides[currentSlideIndex].text || title" />
    }
  </div>

  @if (slides[currentSlideIndex].requiresPin && unlockPin) {
  <div class="unlock-pin">
    @for (pinNumber of unlockPin.split(''); track $index) {
    <span class="pin-number">{{ pinNumber }}</span>
    }
  </div>
  }

  @if (slides.length > 1) {
  <div class="slider-navigation">
    <button type="button"
            class="slider-arrow"
            [disabled]="isFirstSlide"
            (click)="previousSlide()"
            aria-label="Previous step">

      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11 7L6 12L11 17M6 12H18" />
      </svg>
    </button>

    <div class="slide-counter">
      {{ currentSlideIndex + 1 }}/{{ slides.length }}
    </div>

    <button type="button"
            class="slider-arrow"
            [disabled]="!canMoveToNextSlide"
            (click)="nextSlide()"
            aria-label="Next step">

      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13 7L18 12L13 17M18 12H6" />
      </svg>
    </button>
  </div>
  }
</div>
}
